const borderHex = (hex: string, dashed: boolean) =>
	`url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${encodeURIComponent(hex)}' stroke-width='2'${dashed ? " stroke-dasharray='6 6'" : ''} rx='4' ry='4'/%3e%3c/svg%3e")`;

const DASHED_DEFAULT = borderHex('#c7ccd1', true);
const DASHED_DRAG = borderHex('#1565c0', true);
const SOLID_DEFAULT = borderHex('#c7ccd1', false);

export const attachmentDropzoneStyles = {
	root: (isDraggingOver: boolean, clickable: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		columnGap: 3,
		rowGap: 3,
		p: 2,
		'@media (max-width: 600px)': {
			p: 1,
			flexWrap: 'wrap',
			rowGap: 0.5
		},
		borderRadius: 1,
		backgroundImage: isDraggingOver
			? DASHED_DRAG
			: clickable
				? DASHED_DEFAULT
				: SOLID_DEFAULT,
		backgroundColor: isDraggingOver
			? 'primary.lighter'
			: clickable
				? 'primary.hover'
				: 'background.paper',
		transition: 'background-color 120ms',
		cursor: clickable ? 'pointer' : 'default',
		outline: 'none',
		...(clickable &&
			!isDraggingOver && {
				'&:hover': {
					backgroundColor: 'primary.lighter'
				}
			})
	}),
	thumbnailRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 2,
		flexWrap: 'nowrap',
		minHeight: 80,
		'@media (max-width: 600px)': {
			flexWrap: 'wrap',
			gap: 1,
			pt: 1
		}
	},
	browseSection: (hasAttachments: boolean) => ({
		display: 'flex',
		flexDirection: 'column',
		alignItems: hasAttachments ? 'flex-start' : 'center',
		justifyContent: 'center',
		gap: 0.5
	}),
	browseSubtext: {
		fontSize: '0.875rem',
		color: 'text.primary'
	},
	helperText: {
		fontSize: '0.75rem',
		color: 'text.secondary'
	},
	maxReachedText: {
		fontSize: '0.875rem',
		color: 'text.secondary',
		maxWidth: 130,
		'@media (max-width: 600px)': {
			width: '100%',
			maxWidth: 'none',
			fontSize: '0.75rem',
			textAlign: 'center'
		}
	},
	hiddenInput: {
		display: 'none'
	},
	errorList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		mt: 1
	}
};
